import { Alert } from "react-bootstrap";
import { getApiErrorMessages } from "../../../../new/api-errors";

const IncidentErrorAlert = ({
    error,
    fallbackMessage = "The incident request could not be completed.",
    ...props
}) => {
    if (!error) return null;

    const messages = getApiErrorMessages(error, fallbackMessage);

    return (
        <Alert variant="danger" role="alert" {...props}>
            <Alert.Heading>Unable to complete the request</Alert.Heading>
            {messages.length === 1 ? (
                <div>{messages[0]}</div>
            ) : (
                <ul className="mb-0">
                    {messages.map((message) => (
                        <li key={message}>{message}</li>
                    ))}
                </ul>
            )}
        </Alert>
    );
};

export default IncidentErrorAlert;
